import { useState } from 'react';
import { Modal } from 'react-bootstrap';

const PRODUCT_ERROR_MAPPINGS = {
  rgr: 'RGR',
  VAT: 'VAT',
  catchCert: 'Catch Cert',
  commaError: 'Comma Error',
  commoditycode: 'HS Code',
  description: 'Description',
  grossMass: 'Gross Mass',
  healthCert: 'Health Cert',
  itemValue: 'Value',
  meursing: 'Meursing',
  netMass: 'Net Mass',
  organic: 'Organic',
  origin: 'Origin',
  packageCount: 'Packages',
  packageType: 'Package Type',
  preferential: 'Pref',
  quantity2: 'Qty 2',
  neeNoridconsignor: 'Consignor',
  invoiceNumber: 'Invoice number',
};

const OverviewModal = ({ show, onHide, headerErrors, productErrors }) => {
  const [copySuccess, setCopySuccess] = useState(false);

  // Flatten and dedupe product errors by item + field before listing them.
  const itemLineErrors = Array.from(
    new Map(
      (productErrors ?? [])
        .flatMap((product) => product.errorDetails ?? [])
        .map((error) => [
          `${error.itemId}-${error.field}`,
          {
            key: `${error.itemId}-${error.field}`,
            label: `Item ${error.itemId}: ${PRODUCT_ERROR_MAPPINGS?.[error.field] ?? 'Unknown'}`,
          },
        ])
    ).values()
  );

  // Function to copy overview details while retaining formatting
  const handleCopyRichText = () => {
    const textElement = document.getElementById('qaOverviewContent');
    const data = new ClipboardItem({
      ['text/html']: new Blob([textElement.innerHTML], { type: 'text/html' }),
    });
    navigator.clipboard.write([data]);

    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 4000); // Reset after 4 seconds
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg">
      <Modal.Header>
        <Modal.Title>Overview</Modal.Title>
        <button type="button" className="btn-close" aria-label="Close" onClick={onHide} />
      </Modal.Header>
      <Modal.Body>
        <div id="qaOverviewContent">
          <p>The following information is required to complete your load:</p>

          {headerErrors?.length > 0 && (
            <>
              <p>
                <strong>Header Fields:</strong>
              </p>
              <ul>
                {headerErrors.map((error) => (
                  <li key={error.field}>{error.name}</li>
                ))}
              </ul>
            </>
          )}

          {itemLineErrors.length > 0 && (
            <>
              <p>
                <strong>Item Line Fields:</strong>
              </p>
              <ul>
                {itemLineErrors.map(({ key, label }) => (
                  <li key={key}>{label}</li>
                ))}
              </ul>
            </>
          )}

          <p>Please provide this information at your earliest convenience.</p>
        </div>

        <div className="d-flex px-2 justify-content-between mt-4">
          <div className="d-flex gap-4 align-items-center">
            <button type="button" className="blue-button-teams" onClick={handleCopyRichText} style={{ width: '12rem' }}>
              Copy to Clipboard
            </button>
            {copySuccess && <div className="text-success">Details copied to clipboard</div>}
          </div>
          <div>
            <button type="button" className="blue-button-teams green-btn" onClick={onHide}>
              Close
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OverviewModal;
